import React, {FC} from 'react';
import {format, subDays} from 'date-fns';
import {observer} from 'mobx-react-lite';
import {CalendarDaysIcon} from '@heroicons/react/24/outline';
import {useOrganization, useOrganizationUsage} from '../../react-sdk/queries';
import {FlexFill, HelpDialog, PageTitle, Spinner} from '../../Components';
import {UsageSection} from './Components';
import {AppState} from '../../AppState';

export const OrgUsage: FC = observer(() => {
  const organizationId = AppState.currentProfile?.organization_id || '';
  const orgQuery = useOrganization(organizationId);
  const usageQuery = useOrganizationUsage(organizationId);
  // TODO: Start/end date and usage type filters

  const org = orgQuery.data;
  if (!org) {
    return (
      <div className="w-full max-w-[860px]">
        <PageTitle>Usage</PageTitle>
        <Spinner mode="dark" />
      </div>
    );
  }

  const usage = usageQuery.data || {};
  const rangeEnd = new Date();
  const rangeStart = subDays(rangeEnd, 90);

  return (
    <div className="w-full max-w-[860px]">
      <PageTitle>
        Usage
        <FlexFill />
        <HelpDialog title="Usage">
          All organizations have access to unlimited eSign Standard and Dynamic Tagging features. Additional features may have usage limits
          based on your plan.
        </HelpDialog>
      </PageTitle>

      <div className="mb-6 flex items-center gap-2 text-sm text-gray-500">
        <CalendarDaysIcon className="h-4 w-4 text-gray-400" />
        Cumulative usage from {format(rangeStart, 'MMM d, yyyy')} to {format(rangeEnd, 'MMM d, yyyy')}
      </div>

      <div className="flex flex-col gap-6">
        <UsageSection org={org} usage={usage[org.id]} badge="Your organization" badgeTone="indigo" />

        {[...(org.children || [])].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((childOrg) => (
          <UsageSection key={childOrg.id} org={childOrg} usage={usage[childOrg.id]} badge="Child organization" />
        ))}
      </div>
    </div>
  );
});
